import React, { useState } from 'react'
// import PropTypes from 'prop-types'
import MomentUtils from '@date-io/moment';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import moment from "moment";
import styled from 'styled-components';
import { createMuiTheme, makeStyles, InputAdornment, Icon } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import "moment/locale/es";

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: { 500: '#5E388A' },
  },
});


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    // border: '1px solid #CCCCCC',
    marginRight: '.5em',
    borderRadius: '12px',
    '&::before': {
      display: 'none'
    },
    '&::after': {
      display: 'none'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#CCCCCC',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5E388A',
      borderWidth: '1px'
    },
    '& input': {
      padding: '12px 0px 12px 14px',
      // color: '#6A6A6A !important',

      // padding: props => props.value ? '15px 8px 15px 8px' : '14px 0px 14px 16px',
      color: '#5E388A !important',
      fontWeight: props => props.filled ? 500 : 'normal',
      fontFamily: '"Open Sans"',
      fontSize: props => props.filled ? '14px' : '16px',
      // color: '#6A6A6A !important',
      width: props => props.inputWidth,
      '&.Mui-disabled::placeholder':{
        opacity: .5
      },
      '&::placeholder': {
        textOverflow: 'ellipsis !important',
        color: '#6A6A6A !important',
        opacity: 1
      }
    },
    "&$focused": {
      borderColor: "#9240C9",
      '& .MuiSvgIcon-root': {
        color: "#9240C9"
      }
    }
  }
}));

const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${({filled}) => filled ? '#ffff' : 'transparent'};
  border: ${({focused}) => focused ? '1px solid #5E388A !important' : '1px solid #CCCCCC'};
  box-sizing: border-box;
  border-radius: 12px;
  align-items: center;
  padding: 0 .5em 0 .3em;
  &:hover{
    border: ${({disabled}) => disabled ? '1px solid #CCCCCC' : '1px solid #333333'};
  }
`
const CrossContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-left: .5em;
  cursor: pointer;
`

const MultiInputDate = ({ value1=null, value2=null, onChange1, onChange2, label1='', label2='', cleanBoth, disabled, minDate1, maxDate2, ...rest }) => {
  const [dropdown1, setDropdown1] = useState(false)
  const [dropdown2, setDropdown2] = useState(false)
  const inputWidth1 = value1 ? `${moment(value1).format('DD MMM YYYY').length}ch` : `${label1.length}ch`
  const inputWidth2 = value2 ? `${moment(value2).format('DD MMM YYYY').length}ch` : `${label2.length}ch`
  const filled = value1 || value2;
  const classes1 = useStyles({inputWidth: inputWidth1, filled});
  const classes2 = useStyles({inputWidth: inputWidth2, filled});
  const [focused, setFocused] = useState(false)
  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <Container filled={filled} focused={focused} disabled={disabled}>
        { value1 &&
          <CrossContainer onClick={cleanBoth}>
            <img src={require('../../../../assets/icons/cross_purple.svg')} alt='cross' />
          </CrossContainer>
        }
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale='es'>
          <DatePicker
            autoOk
            placeholder={label1}
            value={value1}
            onChange={onChange1}
            disabled={disabled}
            onOpen={() => setDropdown1(true)}
            onClose={() => setDropdown1(false)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            format="DD MMM YYYY"
            minDate={minDate1}
            maxDate={value2 || moment('2100-01-01', 'YYYY-MM-DD')}
            inputVariant="standard"
            variant='inline'
            clearable={true}
            InputProps={{
              classes: {
                ...classes1,
                input: classes1.input
              },
              endAdornment: (
                <InputAdornment position={'end'}>
                  <Icon>
                    {
                      dropdown1
                      ? <ArrowDropUpIcon style={{ color: '#5e388a' }} />
                      : <ArrowDropDownIcon style={{ color: disabled ? '#cccccc' : '#5e388a'  }} />
                    }
                  </Icon>
                </InputAdornment>
              )
            }}
            // rightArrowIcon={() => ArrowDropDownIcon}
            style={{ width: '100%' }}
            {...rest}
          />
        </MuiPickersUtilsProvider>
        <ArrowForwardIcon style={{ color:'#B7BCBF' }}/>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale='es'>
          <DatePicker
            autoOk
            placeholder={label2}
            value={value2}
            onChange={onChange2}
            disabled={!value1 || disabled}
            minDate={value1}
            onOpen={() => setDropdown2(true)}
            onClose={() => setDropdown2(false)}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            maxDate={maxDate2}
            format="DD MMM YYYY"
            inputVariant="standard"
            variant='inline'
            clearable={true}
            InputProps={{
              classes: {
                ...classes2,
                input: classes2.input
              },
              endAdornment: (
                <InputAdornment position={'end'}>
                  <Icon>
                    {
                      dropdown2
                      ? <ArrowDropUpIcon style={{ color: '#5e388a' }} />
                      : <ArrowDropDownIcon style={{ color: (!value1 || disabled) ? '#cccccc' : '#5e388a' }} />
                    }
                  </Icon>
                </InputAdornment>
              )
            }}
            // rightArrowIcon={() => ArrowDropDownIcon}
            style={{ width: '100%' }}
            {...rest}
          />
        </MuiPickersUtilsProvider>
      </Container>
    </ThemeProvider>
  )
}

MultiInputDate.propTypes = {

}

export default MultiInputDate
